import React from 'react';
import { Text, View } from 'core';
import { USER_MSG_TYPES, theme, css } from 'constants';
import { IconDeleted } from 'icons';
import { lang } from 'lang';

const styles = css({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 15
  },
  text: {
    color: theme.gray_color_lighten(0.6),
    fontStyle: 'italic',
    marginHorizontal: 5,
    fontSize: theme.font_sm
  }
});

export const DeletedMsg = ({ is_for_me }) => (
  <View style={styles.container}>
    <IconDeleted size={17} color={theme.gray_color_lighten(0.6)} />
    {is_for_me ? <Text style={styles.text}>{lang.DELETED_MSG}</Text> : <Text style={styles.text}>{lang.USER_LAST_MSG[USER_MSG_TYPES.DELETED]}</Text>}
  </View>
);



// WEBPACK FOOTER //
// ./src/components/middle/chat/msgs/deleted.js